import { create } from 'zustand';
import { type CurrencyCode } from '@mibodega/shared-types';

interface CurrencyState {
  currency: CurrencyCode;
  setCurrency: (currency: CurrencyCode) => void;
}

export const useCurrencyStore = create<CurrencyState>((set) => ({
  currency: 'COP',
  setCurrency: (currency) => set({ currency }),
}));
